import axios from "axios";
import { Get, GetEndpoint } from "../services/api_helpers";

export const GetWeather = () => {
  return axios.get("https://meteo.gov.tm/api/current-weather");
};

// laws
export const GetLaws = () => Get("laws");
export const GetCodex = () => Get("kodeksler");
export const GetConstitution = () => Get("constitution");
export const GetConstitutionLaws = () => Get("constitutional-laws");

// laws table
export const GetLawsTable = (location) => GetEndpoint(`laws/${location}`);
export const GetCodexTable = (location) => GetEndpoint(`kodeksler/${location}`);
export const GetConstitutionTable = (location) =>
  GetEndpoint(`constitution/${location}`);
export const GetConstitutionLawsTable = (location) =>
  GetEndpoint(`constitutional-laws/${location}`);

// news
export const GetNews = () => Get("news");
export const GetNewsTable = (location) => GetEndpoint(`news/${location}`);

// gallery
export const Galleries = () => Get("gallery");
export const GalleryCard = (location) => GetEndpoint(`gallery/${location}`);

// cities law-help
export const GetCitizens = () => Get("citizen-receptions");
export const GetCitizensTable = (location) =>
  GetEndpoint(`citizen-receptions/${location}`);

// document sample
export const GetDocumentSample = () => Get("document-samples");
export const GetDocumentSampleTable = (location) =>
  GetEndpoint(`document-samples/${location}`);

// auctions
export const GetSale = () => Get("auctions");
export const GetSaleCard = (location) => GetEndpoint(`auctions/${location}`);

// others
export const GetStateDuty = () => Get("state-duties");
export const GetCollectionDecisions = () => Get("collection-decision");
export const GetFaq = () => Get("faqs");
export const GetCourtcomplains = () => Get("court-complain-categories");
export const GetAbout = () => Get("about");
export const GetPages = () => Get("pages");
export const GetPrivacyPolicy = () => Get("privacy-policy");